import Vue from 'vue'
import App from './App.vue'
import TagManager from '@shared/plugins/TagManager';
Vue.use(TagManager);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('hkraft-nettopp-orderform')
